var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPackage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.67188 23.7188C5.67188 24.2859 6.13594 24.75 6.70312 24.75C7.27031 24.75 7.73438 24.2859 7.73438 23.7188V22.1719H5.67188V23.7188Z",
    fill: "#424242"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0781 1.03125C19.0781 0.464062 18.6141 0 18.0469 0C17.4797 0 17.0156 0.464062 17.0156 1.03125V2.57812H19.0781V1.03125Z",
    fill: "#424242"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.70312C0 7.27031 0.464062 7.73438 1.03125 7.73438H2.57812V5.67188H1.03125C0.464062 5.67188 0 6.13594 0 6.70312Z",
    fill: "#424242"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7188 17.0156H22.1719V19.0781H23.7188C24.2859 19.0781 24.75 18.6141 24.75 18.0469C24.75 17.4797 24.2859 17.0156 23.7188 17.0156Z",
    fill: "#424242"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.70312 0C6.13594 0 5.67188 0.464062 5.67188 1.03125V2.57812H7.73438V1.03125C7.73438 0.464062 7.27031 0 6.70312 0Z",
    fill: "#424242"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.375 0C11.8078 0 11.3438 0.464062 11.3438 1.03125V2.57812H13.4062V1.03125C13.4062 0.464062 12.9422 0 12.375 0Z",
    fill: "#424242"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0156 23.7188C17.0156 24.2859 17.4797 24.75 18.0469 24.75C18.6141 24.75 19.0781 24.2859 19.0781 23.7188V22.1719H17.0156V23.7188Z",
    fill: "#424242"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3438 23.7188C11.3438 24.2859 11.8078 24.75 12.375 24.75C12.9422 24.75 13.4062 24.2859 13.4062 23.7188V22.1719H11.3438V23.7188Z",
    fill: "#424242"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7188 11.3438H22.1719V13.4062H23.7188C24.2859 13.4062 24.75 12.9422 24.75 12.375C24.75 11.8078 24.2859 11.3438 23.7188 11.3438Z",
    fill: "#424242"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.375C0 12.9422 0.464062 13.4062 1.03125 13.4062H2.57812V11.3438H1.03125C0.464062 11.3438 0 11.8078 0 12.375Z",
    fill: "#424242"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0781 3.60938H5.67188C4.53441 3.60938 3.60938 4.53441 3.60938 5.67188V19.0781C3.60938 20.2156 4.53441 21.1406 5.67188 21.1406H19.0781C20.2156 21.1406 21.1406 20.2156 21.1406 19.0781V5.67188C21.1406 4.53441 20.2156 3.60938 19.0781 3.60938ZM19.5938 19.0781C19.5938 19.3633 19.3633 19.5938 19.0781 19.5938H5.67188C5.38725 19.5938 5.15625 19.3633 5.15625 19.0781V5.67188C5.15625 5.38673 5.38725 5.15625 5.67188 5.15625H19.0781C19.3633 5.15625 19.5938 5.38673 19.5938 5.67188V19.0781Z",
    fill: "#424242"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M6.1875 6.1875H18.5625V18.5625H6.1875V6.1875Z",
    fill: "#424242"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7188 5.67188H22.1719V7.73438H23.7188C24.2859 7.73438 24.75 7.27031 24.75 6.70312C24.75 6.13594 24.2859 5.67188 23.7188 5.67188Z",
    fill: "#424242"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M0 18.0469C0 18.6141 0.464062 19.0781 1.03125 19.0781H2.57812V17.0156H1.03125C0.464062 17.0156 0 17.4797 0 18.0469Z",
    fill: "#424242"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackage);
export default __webpack_public_path__ + "static/media/Package.d716286bf839bd976fa4ce15a2f44a0c.svg";
export { ForwardRef as ReactComponent };